import { render } from "./AddRayon.vue?vue&type=template&id=1dde4ee3&ts=true"
import script from "./AddRayon.vue?vue&type=script&lang=ts"
export * from "./AddRayon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__